import { useMemo } from "react";
import { View } from "react-native";
import toastError from "src/helpers/toastError";
import useDevice from "src/hooks/useDevice";
import useDim from "src/hooks/useDim";
import useResolveMaybePromise from "src/hooks/useResolveMaybePromise";
import { useInsideModal } from "src/modals";
import GlobalModal from "src/modals/configs/GlobalModal";
import { paddingLarge, paddingXXL, paddingXXXL } from "src/styles/spacing";
import { useSafeArea } from "src/swsh-native";
import ShareModalCloseButton from "./components/ShareModalCloseButton";
import ShareModalContent from "./components/ShareModalContent";

const ShareModal = () => {
	const dim = useDim();
	const { device } = useDevice();
	const { width, height } = useMemo(() => {
		if (device === "mobile") {
			return {
				width: dim.width,
				height: dim.height,
			};
		} else {
			return {
				width: Math.min(dim.width, 400),
				height: Math.min(dim.height, 800),
			};
		}
	}, [device, dim.height, dim.width]);
	const {
		props: { data, closeVariant, ...restProps },
		closeSelf,
	} = useInsideModal<GlobalModal["Share"]>();
	const resolvedData = useResolveMaybePromise(data, {
		onError: () => {
			toastError();
			closeSelf();
		},
	});
	const safeArea = useSafeArea();

	return (
		<View
			pointerEvents="box-none"
			style={{
				width: dim.width,
				height: dim.height,
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			<ShareModalCloseButton closeVariant={closeVariant} />
			<View
				pointerEvents="box-none"
				style={{
					alignSelf: "center",
					width,
					height,
					paddingTop: safeArea.top + paddingXXXL + 36,
					paddingBottom: safeArea.bottom + paddingXXL,
					rowGap: paddingLarge,
					flex: 1,
				}}
			>
				{!!resolvedData && <ShareModalContent {...restProps} data={resolvedData} />}
			</View>
		</View>
	);
};
export default ShareModal;
